module.exports = __webpack_public_path__ + "static/media/logo.722c3fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/branding/logo.png
// module id = 286
// module chunks = 0